module.exports = __webpack_public_path__ + "static/media/UpWhite.8304a5dc.svg";